export default "__VITE_ASSET__4ve6L2zG__"